import React from 'react';
import { motion } from 'framer-motion';
export function Industries() {
  const industries = [{
    name: 'Healthcare',
    image: 'https://cdn.magicpatterns.com/uploads/nDRYTzJaGCPjKwnQZVnUZu/pexels-karola-g-4021779.jpg',
    benefit: 'HIPAA compliant support and patient outreach systems.'
  }, {
    name: 'E-Commerce',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80',
    benefit: 'Scalable customer service and brand development.'
  }, {
    name: 'Logistics',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&q=80',
    benefit: '24/7 admin support and dispatch coordination.'
  }, {
    name: 'Web Hosting',
    image: 'https://cdn.magicpatterns.com/uploads/gwZm9vcoSyzJxhKtwdDArx/pexels-cookiecutter-17323801.jpg',
    benefit: 'Technical support and high-volume lead generation.'
  }, {
    name: 'Healthcare Staffing',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&q=80',
    benefit: 'Rapid recruitment and compliance management.'
  }];
  return <section id="industries" className="py-12 lg:py-24 bg-slate-900/50" data-id="element-108">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-109">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-10 lg:mb-16 gap-6 sm:gap-8" data-id="element-110">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-111">
            <h2 className="text-brand-accent font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4" data-id="element-112">
              Industries Served
            </h2>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-white" data-id="element-113">
              Tailored for Your Sector
            </h3>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex gap-6 sm:gap-8" data-id="element-114">
            <div className="text-left md:text-center" data-id="element-115">
              <p className="text-2xl sm:text-3xl font-bold text-brand-accent" data-id="element-116">
                98%
              </p>
              <p className="text-[10px] sm:text-xs text-slate-400 uppercase tracking-widest" data-id="element-117">
                Client Retention
              </p>
            </div>
            <div className="text-left md:text-center" data-id="element-118">
              <p className="text-2xl sm:text-3xl font-bold text-brand-accent" data-id="element-119">
                15+
              </p>
              <p className="text-[10px] sm:text-xs text-slate-400 uppercase tracking-widest" data-id="element-120">
                Global Markets
              </p>
            </div>
          </motion.div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-121">
          {industries.map((ind, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="group relative h-80 rounded-3xl overflow-hidden border border-white/10" data-id="element-122">
              <img src={ind.image} alt={ind.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-123" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/40 to-transparent" data-id="element-124" />
              <div className="absolute bottom-0 left-0 p-8 w-full" data-id="element-125">
                <h4 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-126">
                  {ind.name}
                </h4>
                <p className="text-sm text-slate-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-127">
                  {ind.benefit}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}